<script setup lang="ts">
const isOpen = defineModel<boolean>({ default: false });
</script>

<template>
  <BaseDialog
    v-model="isOpen"
    size="md"
  >
    <BaseDialogContent>
      <template #title>{{ $t("bundling.infoModal.title") }}</template>
      <template #content>
        {{ $t("bundling.infoModal.description") }}
      </template>
    </BaseDialogContent>
  </BaseDialog>
</template>
